import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { PropertyCard } from "@/components/PropertyCard";
import { InquiryForm } from "@/components/InquiryForm";
import { usePublishedListings } from "@/data/useListings";

export default function LuxuryVacationHomes() {
  const homes = usePublishedListings("luxury_home") || [];
  return (
    <div data-testid="luxury-page" className="pt-28 md:pt-32">
      <section className="px-6 md:px-12 min-h-[72vh]">
        <div className="max-w-5xl mx-auto">
          <Reveal>
            <span className="text-xs sm:text-sm tracking-[0.2em] uppercase font-medium text-[#8A9A86]">
              Vacation Homes
            </span>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-6 text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-light leading-[1.02] text-[#1C1917]">
              Entire-home stays — curated and coming soon
            </h1>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="mt-8 text-lg md:text-xl text-[#44403C] leading-relaxed font-light max-w-3xl">
              Masaya Hospitality is adding a dedicated collection of entire-home rentals for
              families, groups, and leisure travelers across the Austin area. These listings will be
              presented separately from our furnished-room inventory, with their own photography,
              amenities, and direct-booking availability.
            </p>
          </Reveal>

          {homes.length === 0 && (
            <Reveal delay={0.3}>
              <div className="mt-10" data-testid="luxury-coming-soon">
                <div className="inline-flex items-center gap-2 rounded-full bg-[#F3F6F2] text-[#4A6A48] px-4 py-1.5 text-xs font-medium tracking-[0.12em] uppercase">
                  <Clock className="w-3.5 h-3.5" strokeWidth={2} /> Coming Soon
                </div>
                <h2 className="mt-5 text-2xl md:text-3xl font-light tracking-tight text-[#1C1917] max-w-2xl">
                  Our vacation homes are being prepared.
                </h2>
                <p className="mt-3 text-base text-[#44403C] font-light leading-relaxed max-w-2xl">
                  A dedicated collection of premium entire-home retreats across Austin. Here's what to expect:
                </p>
                <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-3 max-w-2xl">
                  {["Premium, designer-furnished entire homes", "Elevated amenities and curated comforts", "Ideal for groups, celebrations & leisure travel", "Concierge-level Masaya hospitality"].map((t) => (
                    <li key={t} className="flex items-start gap-2.5 text-sm text-[#44403C]"><Check className="w-4 h-4 text-[#8A9A86] mt-0.5 shrink-0" strokeWidth={2} /> {t}</li>
                  ))}
                </ul>
                <div className="mt-10"><InquiryForm category="luxury_home" categoryLabel="Vacation Homes" /></div>
                <Link to="/properties" data-testid="luxury-view-furnished" className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-[#8A9A86] hover:text-[#1C1917] transition-colors">
                  Browse our available Furnished Units <ArrowUpRight className="w-4 h-4" strokeWidth={1.75} />
                </Link>
              </div>
            </Reveal>
          )}
        </div>
        {homes.length > 0 && (
          <div className="max-w-7xl mx-auto mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="luxury-listings">
            {homes.map((u, i) => <PropertyCard key={u.slug} property={u} index={i} />)}
          </div>
        )}
      </section>
    </div>
  );
}
